import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {SettingService} from "../../store/setting/setting.service";

/**
 * Generated class for the SettingPersonalDataPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-personal-data',
  templateUrl: 'setting-personal-data.html',
})
export class SettingPersonalDataPage {

  public personalData: {firstName: string, lastName: string} = {firstName: null, lastName: null}

  private _settings: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private settingService: SettingService) {
    this._settings = this.navParams.get('settings');

    this.personalData.firstName = this._settings.personalData.firstName;
    this.personalData.lastName = this._settings.personalData.lastName;
  }

  public save(): void {
    this._settings.personalData = this.personalData;
    this.settingService.set(this._settings, false);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingPersonalDataPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-personal-data/setting-personal-data.ts